import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Card,
    CardMedia,
    CardActionArea,
    CardContent,
    CardHeader,
    Typography,
    Tooltip,
} from "@mui/material";
import RenderDate from "../../../Common/Date/RenderDate";
import TMSAvatar from "../TMSAvatar";

import { eventAttendanceBadge } from "./EventFunctions";

function EventCard({ data }) {
    const image =
        data?.image ??
        "https://cdn.premierit.com/images/banners/themes/office/bnr-office-meeting.png";

    const badge = eventAttendanceBadge(data?.attendance?.status);

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={`/tms/events/${data.id}`}
                centerRipple={true}
            >
                {image && (
                    <CardMedia
                        component="img"
                        height="250"
                        image={image}
                        alt={data.name}
                    />
                )}

                <CardHeader
                    disableTypography
                    avatar={
                        <Tooltip title="Go to event" arrow>
                            <TMSAvatar type="event" badge={badge} />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            {data.name}
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            <RenderDate date={data.dateStart} />
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body2">
                        {data?.description || ""}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default EventCard;
